module.exports = __webpack_public_path__ + "img/peach-picking princess.796dac76.png";